/**
 * Index.js provides abstract actions which
 * may modify application wide state.
 *
 * This module is called serverside to restore
 * app state on initial load, using the
 * 'nuxtServerInit' hook.  Do not use this
 * hook for prefetching data.  That should be
 * done in the fetch or asyncData hooks.
 */

import { RESET } from '~/lib/helpers/editor-mutations'

const PLACEHOLDER_ENTERPRISE = {
  is_loading: true,
  is_whitelabel: false,
  id: 'eid_422203f0-477b-492b-9847-689feab1452a',
  pool_client_id: process.env.DEFAULT_POOL_CLIENT_ID,
  pool_id: process.env.DEFAULT_POOL_ID,
  pool_region: process.env.DEFAULT_POOL_REGION,
  name: '',
  features: {
    purchases: true,
  },
  theme: {
    logo: {
      light_url: '',
      dark_url: '',
    },
    palette: {
      primary: 'grey',
      secondary: 'grey',
    },
    fallback_url: '',
    social_links: [],
    footer: {
      columns: [],
      include_social_links: false,
    },
    trustpilot: {
      id: '5be01d787b5e5b0001ebb6bb',
      url: 'https://www.trustpilot.com/review/logo.com',
    },
  },
}

export const state = () => {
  return {
    loginAttempts: 0,
    passwordResets: 0,
    numOverlays: 7,
    enterprise: PLACEHOLDER_ENTERPRISE,
  }
}

export const mutations = {
  setEnterprise(state, enterprise) {
    state.enterprise = enterprise
  },
}

/* Return functions when data is static, but results should not be cached */
export const getters = {
  /** Indicates theming has not been loaded yet  */
  themeIsLoading: state => state.enterprise.is_loading,

  isExpired: state => () => {
    return new Date(state.session.expires).getTime() - new Date().getTime() <= 0
  },
  isLoggedIn: state => () => {
    return !!state.session.token
  },
  darkLogo(state) {
    return state.enterprise.theme.logo.dark_url
  },
  lightLogo(state) {
    return state.enterprise.theme.logo.light_url
  },
  companyName(state) {
    return state.enterprise.name
  },
  fallbackUrl(state) {
    return state.enterprise.theme.fallback_url
  },
  isUs(state) {
    return !state.enterprise.is_whitelabel
  },
  isWhitelabel(state) {
    return !!state.enterprise.is_whitelabel
  },
  domain(state) {
    return state.enterprise.domain
  },
}

export const actions = {
  async logout({ commit }) {
    commit('cart/reset')
    commit('app/reset')
    commit('session/reset')
    commit('favourites/reset')
  },

  /**
   * Reset the entire application state to square one.
   */
  async reset({ commit }) {
    commit('cart/reset')
    commit('app/reset')
    commit('favourites/reset')
    commit('editor/' + RESET)
  },
}
